import { createStructuredSelector } from 'reselect'
import {
  MGMT_COMPONENT_LIST, MGMT_COMPONENT_LIST_SUCCESS, MGMT_COMPONENT_LIST_ERROR,
  MGMT_COMPONENT_PAGE_SET, MGMT_COMPONENT_ADD, MGMT_COMPONENT_ADD_SUCCESS,
  MGMT_COMPONENT_ADD_ERROR, MGMT_COMPONENT_ADD_CHANGE, MGMT_COMPONENT_DETAIL,
  MGMT_COMPONENT_DETAIL_SUCCESS, MGMT_COMPONENT_DETAIL_ERROR, MGMT_COMPONENT_UPDATE,
  MGMT_COMPONENT_UPDATE_SUCCESS, MGMT_COMPONENT_UPDATE_ERROR,
} from '../../actions';

export const NAME = 'mgmt_component';

export const MgmtComponentList = (page, num_page, orderBy, filters) => ({ type: MGMT_COMPONENT_LIST, payload: { page, num_page, orderBy, filters } });
export const MgmtComponentListSuccess = (data) => ({ type: MGMT_COMPONENT_LIST_SUCCESS, payload: data });
export const MgmtComponentListError = (error) => ({ type: MGMT_COMPONENT_LIST_ERROR, payload: error });
export const MgmtComponentPageSet = (data) => ({ type: MGMT_COMPONENT_PAGE_SET, payload: data });
export const MgmtComponentAddChangeSet = (data) => ({ type: MGMT_COMPONENT_ADD_CHANGE, payload: data });
export const MgmtComponentAdd = (data) => ({ type: MGMT_COMPONENT_ADD, payload: data });
export const MgmtComponentAddSuccess = (message) => ({ type: MGMT_COMPONENT_ADD_SUCCESS, payload: message });
export const MgmtComponentAddError = (error) => ({ type: MGMT_COMPONENT_ADD_ERROR, payload: error });
export const MgmtComponentDetail = (data) => ({ type: MGMT_COMPONENT_DETAIL, payload: data });
export const MgmtComponentDetailSuccess = (data) => ({ type: MGMT_COMPONENT_DETAIL_SUCCESS, payload: data });
export const MgmtComponentDetailError = (error) => ({ type: MGMT_COMPONENT_DETAIL_ERROR, payload: error });
export const MgmtComponentUpdate = (data) => ({ type: MGMT_COMPONENT_UPDATE, payload: data });
export const MgmtComponentUpdateSuccess = (message) => ({ type: MGMT_COMPONENT_UPDATE_SUCCESS, payload: message.message });
export const MgmtComponentUpdateError = (error) => ({ type: MGMT_COMPONENT_UPDATE_ERROR, payload: error });

const mgmt_component = (state) => state[NAME];
export const MgmtComponentSelector = createStructuredSelector({ mgmt_component });
